import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a chunk loading error
    if (error?.message?.includes('Loading chunk') || 
        error?.message?.includes('ChunkLoadError')) {
      // Reload once automatically
      const hasReloaded = sessionStorage.getItem('chunk-error-reloaded');
      if (!hasReloaded) {
        sessionStorage.setItem('chunk-error-reloaded', 'true');
        window.location.reload();
        return { hasError: false };
      }
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught:', error, errorInfo);
    
    // If critical error persists, silently redirect to home
    if (this.state.hasError) {
      sessionStorage.clear();
      window.location.href = '/';
    }
  }

  render() {
    // Don't show anything, just let it work
    return this.props.children;
  }
}

export default ErrorBoundary;
